function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "ic-customers-18px",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("polygon", {
  id: "Path",
  points: "0 0 18 0 18 18 0 18"
}), React.createElement("path", {
  d: "M15,15.0666667 C15,15.4348565 14.7015232,15.7333333 14.3333333,15.7333333 C13.9651435,15.7333333 13.6666667,15.4348565 13.6666667,15.0666667 L13.6666667,13.7333333 C13.6666667,12.6287638 12.7712362,11.7333333 11.6666667,11.7333333 L6.33333333,11.7333333 C5.22876383,11.7333333 4.33333333,12.6287638 4.33333333,13.7333333 L4.33333333,15.0666667 C4.33333333,15.4348565 4.0348565,15.7333333 3.66666667,15.7333333 C3.29847683,15.7333333 3,15.4348565 3,15.0666667 L3,13.7333333 C3,11.8923842 4.49238417,10.4 6.33333333,10.4 L11.6666667,10.4 C13.5076158,10.4 15,11.8923842 15,13.7333333 L15,15.0666667 Z M9,9.06666667 C7.15905083,9.06666667 5.66666667,7.5742825 5.66666667,5.73333333 C5.66666667,3.89238417 7.15905083,2.4 9,2.4 C10.8409492,2.4 12.3333333,3.89238417 12.3333333,5.73333333 C12.3333333,7.5742825 10.8409492,9.06666667 9,9.06666667 Z M9,7.73333333 C10.1045695,7.73333333 11,6.83790283 11,5.73333333 C11,4.62876383 10.1045695,3.73333333 9,3.73333333 C7.8954305,3.73333333 7,4.62876383 7,5.73333333 C7,6.83790283 7.8954305,7.73333333 9,7.73333333 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})));

var SvgIcCustomers18Px = function SvgIcCustomers18Px(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCustomers18Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-customers-18px.309f288e.svg";
export { ForwardRef as ReactComponent };